var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('div',{staticClass:"form-group flutuante col-12"},[_c('p',[_vm._v("https://www.cdlbh.com.br/produto/centro-de-convencoes-cdl-bh/")])])])}
var staticRenderFns = []

export { render, staticRenderFns }